import { serverURL } from "../utils";

export const getDesigns = async () => {
  const response = await fetch(`${serverURL()}/designs`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  } else {
    const designs = await response.json();
    return designs;
  }
};

export const getProductStock = async (id) => {
  const response = await fetch(`${serverURL()}/inventory/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message);
  } else {
    const productStock = await response.json();
    return productStock;
  }
};

export const logError = async (errorObj) => {
  fetch(`${serverURL()}/log-error`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ error: errorObj }),
  });
};
